import { useEffect, useRef, useContext } from 'react'
import GoogleAnalytics from 'react-ga'
import { useSelector } from 'react-redux'

import { useOnScreen } from '../../hooks/useOnScreen'
import { botContext } from '../../contexts/BotContext'
import Header from '../Header'
import ChatBox from '../ChatBox'
import OptionsContainer from '../OptionsContainer'
import InputContainer from '../InputContainer'
import ResultsContainer from '../ResultsContainer'
import { AnalyticsEvents, AnalyticsActions } from '../../store/constants/Analytics'

import './style.css'
import { sendResultClick } from '../../store/httpServices'

const Bot = () => {
  const { chatMessages, isLoading, userInput } = useContext(botContext)
  const { activityId, data, consultantId } = useSelector((state) => state.consultant)
  const chatEndRef = useRef(null)
  const isChatEndOnScreen = useOnScreen(chatEndRef)

  useEffect(() => {
    if (chatEndRef.current && !isChatEndOnScreen) {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [isChatEndOnScreen, isLoading])

  const handleResultClick = (result) => {
    if (process.env.NODE_ENV === 'production'){
      const newParams = {
        optionId: result.id,
        step: data.step + 1,
        consultantId: consultantId,
        activityId: activityId,
        choices: data.choices,
      }

      sendResultClick(newParams)

      GoogleAnalytics.event({
        category: AnalyticsEvents.CONSULTANT,
        action: AnalyticsActions.RESULT_CLICKED(result.id),
        label: result.name,
      })
    }
  }

  return (
    <div className="overflow-hidden relative flex flex-col h-full">
      <div className="pb-7 w-full sticky top-0 app-bot-header-container z-10">
        <Header />
      </div>

      <div className="overflow-y-auto -mt-7 pt-7 flex-auto">
        {chatMessages.map(({ isConsultant, type, payload }, index) => (
          <div key={index} className="mb-5">
            {type === 'message'
              ? (
                <div className="px-6">
                  <ChatBox text={payload.text} isConsultant={isConsultant} />
                </div>
              )
              : <ResultsContainer tips={payload.tips} onClickResult={handleResultClick} />
            }
          </div>
        ))}

        {isLoading && (
          <div className="mb-5 px-6">
            <ChatBox isConsultant isTyping />
          </div>
        )}

        <div ref={chatEndRef} />
      </div>

      {!isLoading && userInput && (
        (userInput.type === 'options' && (
          <OptionsContainer options={userInput.options} isLoading={isLoading} />
        )) ||
        (userInput.type === 'input' && (
          <InputContainer onSubmit={userInput.onSubmit} type={userInput.inputType} adviceText={userInput.adviceText} placeholder={userInput.placeholder} />
        ))
      )}
    </div>
  )
}

export default Bot
